import { NavigateNext } from "@mui/icons-material";
import { Breadcrumbs, BreadcrumbsProps, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { useBreadcrumbs } from "../contexts/BreadcrumbContext";

type BreadcrumbItem = {
  label: string;
  to: string;
};

type CustomBreadcrumbsProps = {
  items?: BreadcrumbItem[];
};

const CustomBreadcrumbs = (
  props: CustomBreadcrumbsProps & BreadcrumbsProps,
) => {
  const { breadcrumbs } = useBreadcrumbs();
  const { items, ...restProps } = props;
  const breadcrumbItems = items ?? breadcrumbs;

  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumb"
      {...restProps}
    >
      {breadcrumbItems?.map((breadcrumb, index) => (
        <React.Fragment key={`breadcrumb-${index}`}>
          {index === breadcrumbItems.length - 1 ? (
            <Typography key={breadcrumb.to} variant="body1">
              {breadcrumb.label}
            </Typography>
          ) : (
            <>
              {breadcrumb.to ? (
                <Link
                  key={breadcrumb.to}
                  className="text-gray-400"
                  underline="none"
                  component={RouterLink}
                  to={breadcrumb.to}
                  variant="body1"
                >
                  {breadcrumb.label}
                </Link>
              ) : (
                <Typography variant="body1" className="text-gray-400">
                  {breadcrumb.label}
                </Typography>
              )}
            </>
          )}
        </React.Fragment>
      ))}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
